import React, { useState } from "react";
import { Modal, List, Divider, Input, Empty } from "antd";
import { RightOutlined } from "@ant-design/icons";
import ScheduleConnection from "../../Commands/Modals/ScheduleConnection";
import { useResetSAIDIMutation } from "../../../services/commands.services";

const CommandModal = ({
  isVisible,
  onClose,
  groupedContent,
  handleCommandType,
  selectedcommand,
  command,
  setcommand,
  setselectedcommand,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  // Filter grouped content based on the search term
  const filteredContent = Object.entries(groupedContent).reduce(
    (acc, [group, items]) => {
      const filteredItems = items.filter(
        (item) =>
          item.command.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
      if (filteredItems.length > 0) {
        acc[group] = filteredItems;
      }
      return acc;
    },
    {}
  );

  const hasResults = Object.keys(filteredContent).length > 0;

  const [resetSAIDI, { isLoading: resetSAIDIlaoding }] =
    useResetSAIDIMutation();

  return (
    <>
      {/* Command List Modal */}
      <Modal
        title="Command List"
        open={isVisible}
        onCancel={onClose}
        footer={null}
      >
        <h1 className="m-0">Search for command </h1>

        {/* Search Input */}
        <Input
          placeholder="Search for a command or description"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: 16 }}
        />

        {/* Scrollable Content */}
        <div style={{ maxHeight: "500px", overflowY: "scroll" }}>
          {hasResults ? (
            Object.entries(filteredContent).map(([group, items]) => (
              <div key={group}>
                <Divider orientation="left">{group}</Divider>
                <List
                  dataSource={items}
                  renderItem={(item) => (
                    <List.Item
                      onClick={() => {
                        setselectedcommand(item.command);
                        if (item.command === "RST05") {
                        }
                        setcommand((prev) => {
                          if (item.command === "CON") {
                            return {
                              ...prev,
                              CON: true,
                            };
                          } else if (item.command === "DIS") {
                            return {
                              ...prev,
                              DIS: true,
                            };
                          } else if (item.command === "LUP") {
                            return {
                              ...prev,
                              LUP: true,
                            };
                          } else if (item.command === "TON") {
                            return {
                              ...prev,
                              TON: true,
                            };
                          } else if (item.command === "OFF") {
                            return {
                              ...prev,
                              OFF: true,
                            };
                          } else {
                            return {
                              ...prev,
                            };
                          }
                        });
                        onClose();
                      }}
                      actions={[<RightOutlined />]}
                      style={{ padding: "10px 0", cursor: "pointer" }}
                    >
                      <List.Item.Meta
                        title={<b>{item.title}</b>}
                        description={item.description}
                      />
                    </List.Item>
                  )}
                />
              </div>
            ))
          ) : (
            <Empty
              description={
                <span>
                  No results found for "<b>{searchTerm}</b>"
                </span>
              }
              style={{ marginTop: 50 }}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default CommandModal;
